export const dayStyle = (a: any) => {
  const day = a.getDay() == 5 || a.getDay() == 6;
  return day ? "sday" : "";
};

export const scales = {
  hour: [
    { unit: "day", step: 1, format: "MMM dd" },
    { unit: "hour", step: 1, format: "HH:mm" },
  ],

  day: [
    { unit: "month", step: 1, format: "MMMM yyyy" },
    { unit: "day", step: 1, format: "dd" },
  ],

  week: [
    { unit: "month", step: 1, format: "MMMM yyyy" },
    { unit: "week", step: 1, format: "'Week' ww" },
  ],

  month: [
    { unit: "year", step: 1, format: "yyyy" },
    { unit: "month", step: 1, format: "MMM" },
  ],
};

export const cellWidthMap = {
  hour: 60,
  day: 40,
  week: 40,
  month: 20,
};

export const legend = [
  {
    title: "Category & Sub-Category",
    className: "bg-[#00ba94]",
  },
  {
    title: "Planned",
    className: "bg-[#E4E2D8]",
  },
  {
    title: "Actual",
    className: "bg-[#BCB48E]",
  },
  {
    title: "% Complete",
    className: "bg-primary",
  },
];

export const taskOption = [
  { label: "All Task", value: "all" },
  { label: "Draft", value: "draft" },
  { label: "Planned", value: "planned" },
  { label: "Completed", value: "completed" },
];